export const removePlatformHook = (_, __, next) => {
  localStorage.removeItem("platform");

  next();
};
